var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3444 6.48942L11.8688 5.62002L9.38808 0.279449C9.20657 -0.0931496 8.72253 -0.0931496 8.54102 0.279449L6.06033 5.65107L0.614906 6.48942C0.221625 6.55152 0.0703636 7.07937 0.372887 7.35882L4.33594 11.5505L3.39812 17.419C3.33762 17.8226 3.7309 18.1642 4.09392 17.9158L9.02506 15.1523L13.9259 17.9158C14.2587 18.1021 14.6822 17.7916 14.5915 17.419L13.6537 11.5505L17.6167 7.35882C17.8587 7.07937 17.7377 6.55152 17.3444 6.48942Z",
    fill: "#52503B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5377,
    height: 18,
    fill: "white",
    transform: "translate(0.203766)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e24a05e6b6383c1c89c9ae42af7ec1a0.svg";
export { ForwardRef as ReactComponent };